import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Логируем для диагностики
    console.error('UI error boundary caught an error:', error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-4 text-center">
          <h5 className="mb-2">Упс! Что-то пошло не так.</h5>
          <p className="text-muted mb-3">Попробуйте обновить страницу или продолжить работу.</p>
          <div className="d-flex justify-content-center gap-2">
            <button className="btn btn-primary btn-sm" onClick={this.handleReload}>
              Обновить
            </button>
            <button className="btn btn-outline-secondary btn-sm" onClick={this.handleReset}>
              Продолжить
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
